import type { LogEntry } from '../../types/db';

export const log: LogEntry[] = [
  {
    id: 'l-1',
    time: '03:14',
    agent: 'code',
    summary: 'Build gerepareerd · PR #142 klaar voor review',
    level: 'zelf',
    where: 'lokaal',
    outcome: 'uitgevoerd',
    traceId: 'nacht-build',
    night: true,
  },
  {
    id: 'l-2',
    time: '05:30',
    agent: 'mail',
    summary: '12 mails gesorteerd, 3 voor jou',
    level: 'zelf',
    where: 'lokaal',
    outcome: 'uitgevoerd',
    night: true,
  },
  {
    id: 'l-3',
    time: '02:40',
    agent: 'boekhouding',
    summary: '2 bonnen als concept ingeboekt',
    level: 'zelf',
    where: 'lokaal',
    outcome: 'uitgevoerd',
    traceId: 'bonnen',
    night: true,
  },
];
